import { fmt } from "@/lib/load/products";

const toneOf = (x) => (x.isOpen ? "safe" : x.outOfService ? "caution" : "danger");

export const TankList = ({ tanks, t }) => (
  <div className="ust-tanks" data-testid="ust-tanks">
    {tanks.map((x, i) => (
      <div key={x.tankId || i} className={`ust-tank ${x.isOpen ? "" : "ust-tank-off"}`} data-testid={`ust-tank-${i}`}>
        <div><b>{x.substance || t("Unknown product")}</b>
          <div className="card-sub">{x.tankId}{x.installed ? ` · ${t("installed")} ${x.installed.slice(0, 4)}` : ""}{x.wall ? ` · ${x.wall}` : ""}</div></div>
        <div className="ust-tank-right">
          <span className="ust-cap">{x.capacity ? `${fmt(x.capacity)} gal` : t("size unknown")}</span>
          <span className={`ust-status tone-text-${toneOf(x)}`} data-testid={`ust-tank-status-${i}`}>{x.status}</span>
        </div>
      </div>
    ))}
  </div>
);
